
import { carrieBio, charlotteBio, samanthaBio } from './mirandaBios'
import { carrieReviewerReviewHinge, charlotteReviewerReviewBumble, samanthaReviewerReviewTinder } from './mirandaReviewerReviews'

export const carrieReviewerProfile = {
  _id: 'carrieReviewerProfileId',
  userId: 'carrieUserId',
  email: 'carrie@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-5.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...carrieBio },
  profileReviews: [
    // { ...carrieProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...carrieReviewerReviewHinge }
  ],
}

export const charlotteReviewerProfile = {
  _id: 'charlotteReviewerProfileId',
  userId: 'charlotteUserId',
  email: 'charlotte@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-charlotte-1-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...charlotteBio },
  profileReviews: [
    // { ...charlotteProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...charlotteReviewerReviewBumble }
  ],
}

export const samanthaReviewerProfile = {
  _id: 'samanthaReviewerProfileId',
  userId: 'samanthaUserId',
  email: 'samantha@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-samantha-5-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...samanthaBio },
  profileReviews: [
    // { ...samanthaProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...samanthaReviewerReviewTinder }
  ],
}